import { createGlobalStyle } from 'styled-components/macro';
import { V4Theme } from './v4-theme';
import { css } from './styled';

export const GlobalStyles = createGlobalStyle<{ theme: V4Theme }>`
  ${({ theme }) => css`
    body {
      color: ${theme.colors.gray[800]};
    }

    /* Сброс стандартных стилей */
    p,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: 'Roboto', sans-serif;
      margin: 0;
      padding: 0;
    }

    h2 {
      color: ${theme.colors.gray[800]};
      ${theme.fonts['heading-1'].css}
    }

    h3 {
      color: ${theme.colors.gray[800]};
      ${theme.fonts['heading-2'].css}
    }

    h4 {
      color: ${theme.colors.gray[600]};
      ${theme.fonts['heading-3'].css}
    }

    h5 {
      color: ${theme.colors.gray[500]};
      ${theme.fonts['heading-4'].css}
    }

    h6 {
      color: ${theme.colors.gray[400]};
      ${theme.fonts['heading-5'].css}
    }

    /* Общий скроллбар */
    ::-webkit-scrollbar {
      width: 20px;
      background-color: transparent;
    }

    ::-webkit-scrollbar-track {
      margin-block: ${theme.spacings.xs};
      border-radius: ${theme.radiuses.full};
      border: 8px solid transparent;
      background-clip: padding-box;
    }

    ::-webkit-scrollbar-thumb {
      background-color: ${theme.colors.gray[200]};
      border-radius: ${theme.radiuses.full};
      border: 8px solid transparent; /* Такой же border как у track */
      background-clip: padding-box; /* Фон thumb тоже обрезается по border */

      &:hover {
        background-color: ${theme.colors.gray[500]};
      }
    }
  `}
`;
